<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dq8Hv7/tc-custom/9781455564934.jpg?1737127606856" alt="This image is the cover for the book Midnight Clear, Last Chance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Midnight Clear, Last Chance
      </h1>
      <p class="bookDescription body article font2">
        <b>A single mother finds a second chance with the new doctor in this small town holiday romance from a <i>USA Today–</i>bestselling author.</b><br/><br/>Dr. Tom Crawford isn't feeling the spirit of the season when he arrives in Last Chance. Far from friends and family, he's the odd man out in this town of gossiping, tight-knit Southerners—until he meets a sweetly sexy single mom who makes him feel welcome. Suddenly the handsome doctor is thinking he's finally found a place to call home.<br/><br/>Local florist Teri Summers has her hands full of mistletoe in preparation for the holiday, yet finding someone to kiss is her last priority. But when the gorgeous new doctor makes a connection with her special needs son, Aiden, Teri finds herself wondering if she's finally found happiness in this season of joy. For Teri and Tom, Last Chance may be their best chance at love . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hope Ramsay
      </h2>
      
      <p class="authorDescription body article"><B>Hope Ramsay</B> is a <I>USA Today</I> bestselling author of heartwarming contemporary romances set below the Mason-Dixon Line and inspired by the summers she spent with her large family in South Carolina.  She has two grown children, a demanding lap cat named Simba who was born in Uganda, and a precious Cockapoo puppy named Daisy. She lives in Virginia where, when she's not writing, she's knitting or playing her forty-year-old Martin guitar.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a8d0ef32